import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import useDebounce from '@/common/hooks/useDebounce.ts';
import { provinceRequest } from '@/common/queries/selections/provinceRequest';
import { SelectionOptionsType } from '@/common/types/SelectionOptions.type.ts';

const useCountyRequest = () => {
  const [province, setProvince] = useState<string>('');
  const debounce = useDebounce();
  const onProvinceSearchChange = (value: string) => {
    if (value) {
      debounce(() => {
        setProvince(value);
      }, 1000);
    } else {
      setProvince(value);
    }
  };

  const provinceQuery = useQuery({
    queryKey: ['province', province],
    gcTime: 1000 * 60 * 30,
    queryFn: () => provinceRequest({ province }),
    select: (data): SelectionOptionsType[] =>
      {
        return data?.map((item) => ({ label: item.name, value: item.id }))},
  });
  return { onProvinceSearchChange, provinceQuery };
};

export default useCountyRequest;
